export default function WaveBottom() {
  return (
    <div className="wave-wrap">
      <div className="wave-inner">
        {[0, 1].map(k => (
          <svg key={k} viewBox="0 0 1440 80" preserveAspectRatio="none"
            style={{ width: "50%", height: 80, display: "block" }}>
            <path d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z" fill="white"/>
          </svg>
        ))}
      </div>
    </div>
  );
}
